import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { RadioChangeEvent } from 'antd/lib/radio';
import { get } from 'lodash';
import { Radio } from 'antd';
import { RootState } from '@share/utils';
import { ILoginState, IMyProfileState } from '@share/store/slices';
import { IUserCard } from '@share/common-types';
import PaymentCard from './payment-card';
import { CreditCardItem } from '../../components/common/credit-cards-list/credit-card-item';

interface IMapStateToProps {
  myProfileStore: IMyProfileState;
  loginStore: ILoginState;
}

interface IProps extends IMapStateToProps, RouteComponentProps, WrappedComponentProps {
  selectable?: boolean;
  hideDelete?: boolean;
  hideIfNoData?: boolean;
  isCheckout?: boolean;

  selectedCardId?: string;
  onSelectCard?: (selectedCard: IUserCard) => void;
}

function SavedCardsComponent(props: IProps) {

  const { myProfileStore, loginStore, selectable, hideDelete, hideIfNoData, isCheckout, selectedCardId, onSelectCard } = props;
  const { result, loadingCards } = myProfileStore;
  const { account } = loginStore;
  const { userCards } = result;

  const handleOnChange = (selectedValue: RadioChangeEvent) => {
    const selectedCard = get(userCards?.filter((c: any) => c?.id === selectedValue.target.value), '[0]');

    onSelectCard?.(selectedCard as any);
  }

  if (hideIfNoData && !userCards?.length && !loadingCards) {
    return null;
  }

  return (
    <>
    {
      isCheckout ?
        <>
          <div style={{ marginBottom: isCheckout ? '0px' : '25px' }}>
            {userCards?.length ? (
              <div className="credit-cards-list__credit-card-container">
                {selectable ? (
                  <Radio.Group value={selectedCardId} onChange={handleOnChange} disabled={loadingCards}>
                    {userCards.map((card, index) => 
                      <Radio key={index} value={card?.id}>
                        <CreditCardItem card={card} hideDelete={hideDelete} />
                      </Radio>)}
                  </Radio.Group>) : 
                  userCards.map((card, index) => <CreditCardItem key={index} card={card} hideDelete={hideDelete} />)}
              </div>) : (
              <FormattedMessage id="available.cards.no_card" />)}
          </div>
          {account?.enableInsurance ? (
          <div style={{ marginBottom: isCheckout ? '0px' : '25px', marginTop: '10px' }}>
            <FormattedMessage id="insurance.saved_card" />
          </div>) : null}
        </>
        :
        <div className="row g-sm-4 g-3">
          {userCards?.map((card, index) => (
            <div key={index} className="col-md-6">
              <PaymentCard key={index} card={card} />
            </div>
          ))}
        </div>
    }
    </>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    myProfileStore: state.myProfileStore,
    loginStore: state.loginStore,
  };
};

const ComponentIntl = injectIntl(SavedCardsComponent);

const SavedCards = connect(mapStateToProps)(withRouter(ComponentIntl));
export default SavedCards;